import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import classnames from 'classnames';
import { map } from 'lodash';

export default class CollapsingTaxAndFees extends Component {
  constructor (props) {
    super(props);

    this.state = {
      toggleTax: false,
      toggleFees: false,
      feeDetailsHeight: 0,
      taxDetailsHeight: 0
    };

    this.handleFeesClick = this.handleFeesClick.bind(this);
    this.handleTaxClick = this.handleTaxClick.bind(this);
  }

  handleTaxClick () {
    const el = this.taxDetailsRef;
    const contentHeight = el.scrollHeight;

    this.setState({
      toggleTax: !this.state.toggleTax,
      taxDetailsHeight: !this.state.toggleTax ? contentHeight : 0
    });
  }

  handleFeesClick () {
    const el = this.feesDetailsRef;
    const contentHeight = el.scrollHeight;

    this.setState({
      toggleFees: !this.state.toggleFees,
      feeDetailsHeight: !this.state.toggleFees ? contentHeight : 0
    });
  }

  render () {
    const {
      toggleFees,
      toggleTax,
      feeDetailsHeight,
      taxDetailsHeight
    } = this.state;

    const {
      addOnsTaxTotal,
      addOnsFeeTotal,
      taxesArray,
      feesArray,
      currency
    } = this.props;

    const taxDetailsStyles = {
      maxHeight: taxDetailsHeight
    };

    const feesDetailsStyles = {
      maxHeight: feeDetailsHeight
    };

    return (
      <div className='tax-and-fees-section'>
        <div className='fees-section'>
          <div className='flex space-between'>
            <div>
              <FormattedMessage
                id='inbox.collapsing_tax_and_fees.fees'
                defaultMessage='Fees'
              />
            </div>
            <div className='fee-total flex'>
              {0 < addOnsFeeTotal && (
                <span className='dropdown-arrow' onClick={this.handleFeesClick}>
                  {toggleFees ? (
                    <span className='custom-arrow up' />
                  ) : (
                    <span className='custom-arrow down' />
                  )}
                </span>
              )}
              <div
                className={classnames('tax-fee-total', {
                  'no-arrow': 0 >= addOnsFeeTotal
                })}
                data-testing-id='fees-total'
              >
                <FormattedNumber
                  value={addOnsFeeTotal}
                  currency={currency}
                  style={'currency'}
                />
              </div>
            </div>
          </div>

          <div
            ref={(ref) => {
              this.feesDetailsRef = ref;
            }}
            className={classnames('fees-details flex column', {
              'show-content': toggleFees
            })}
            style={feesDetailsStyles}
          >
            <div>
              {map(feesArray, (fee, i) => {
                return (
                  <div
                    className='flex space-between tax-detail'
                    key={`fee-${i}`}
                  >
                    <div className='tax-label'>{fee.label}</div>
                    <div className='tax-total'>
                      <div className='pull-right'>
                        <FormattedNumber
                          value={fee.amount}
                          currency={currency}
                          style={'currency'}
                        />
                      </div>
                      <div />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className='tax-section'>
          <div className='flex space-between'>
            <div>
              <FormattedMessage
                id='inbox.collapsing_tax_and_fees.subtotal'
                defaultMessage='Other taxes'
              />
            </div>
            <div className='tax-total flex'>
              {0 < addOnsTaxTotal && (
                <span className='dropdown-arrow' onClick={this.handleTaxClick}>
                  {toggleTax ? (
                    <span className='custom-arrow up' />
                  ) : (
                    <span className='custom-arrow down' />
                  )}
                </span>
              )}
              <div
                className={classnames('tax-fee-total', {
                  'no-arrow': 0 >= addOnsTaxTotal
                })}
                data-testing-id='taxes-total'
              >
                <FormattedNumber
                  value={addOnsTaxTotal}
                  currency={currency}
                  style={'currency'}
                />
              </div>
            </div>
          </div>

          <div
            ref={(ref) => {
              this.taxDetailsRef = ref;
            }}
            className={classnames('tax-details flex column', {
              'show-content': toggleTax
            })}
            style={taxDetailsStyles}
          >
            <div>
              {map(taxesArray, (tax, i) => {
                return (
                  <div
                    className='flex space-between tax-detail'
                    key={`tax-${i}`}
                  >
                    <div className='tax-label'>{tax.label}</div>
                    <div className='tax-total'>
                      <div className='pull-right'>
                        <FormattedNumber
                          value={tax.amount}
                          currency={currency}
                          style={'currency'}
                        />
                      </div>
                      <div />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CollapsingTaxAndFees.propTypes = {
  addOnsTaxTotal: PropTypes.string,
  addOnsFeeTotal: PropTypes.string,
  taxesArray: PropTypes.array,
  feesArray: PropTypes.array,
  currency: PropTypes.string
};
